import React, { useState, useEffect, useRef } from 'react';
import Header from '../../components/Header';
import { useHistory } from "react-router-dom";
import styles from './styles.module.css';
import api from '../../services/api_adiantamento';
import { BsFillPlusCircleFill, BsXCircleFill } from "react-icons/bs";
import { left } from '@patternfly/react-core/dist/esm/helpers/Popper/thirdparty/popper-core';

export default function Folha() {

    const [funcoes, setFuncoes] = useState([]);
    const [dpto, setDpto] = useState([]);
    const [modalFuncaoOpen, setModalFuncaoOpen] = useState(false);
    const [salBase, setSalBase] = useState('');
    const [gratFixa, setGratFixa] = useState('');
    const [bpp, setBpp] = useState('');
    const [teto, setTeto] = useState('');
    const [eventos, setEventos] = useState({
        items: [
        ],
        selectItem: 0
    });
    const [selectedFuncao, setSelectedFuncao] = useState({});

    useEffect(() => {
        api.get(`/folha/eventos`).then(function (response) {
            if (selectedFuncao.parametros) {
                if (response.data) {
                    var itens = [];
                    response.data.forEach((evento, index) => {
                        var canpush = true;
                        selectedFuncao.parametros.forEach((parametro) => {
                            if (parametro.idevento === evento.id) {
                                canpush = false;
                            }
                        })
                        if (canpush) {
                            var item = { id: evento.id, text: evento.descricao }
                            itens.push(item);
                        }
                    })
                    var perfs = {};
                    perfs.items = itens;
                    perfs.selectItem = itens[0].id;
                    setEventos(perfs);
                }
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }, [selectedFuncao]);

    function handleClickFuncao(id) {
        var ojbfuncao = Object.assign({}, funcoes.find(funcao => funcao.id === parseInt(id)));
        setSelectedFuncao(ojbfuncao)
        setSalBase(ojbfuncao.sal_base);
        setBpp(ojbfuncao.bpp);
        setGratFixa(ojbfuncao.grat_fixa);
        setTeto(ojbfuncao.teto_hr_extra);
        setModalFuncaoOpen(true);
    }

    function renderRow() {
        return (
            funcoes.map((funcao, index) => {
                return (
                    <tr onClick={() => handleClickFuncao(funcao.id)} key={index}>
                        <td>{(funcao.departamento_id ? funcao.departamento_id.substring(2) : '')}</td>
                        <td>{funcao.descricao}</td>
                        <td>{funcao.sal_base}</td>
                        <td>{funcao.grat_fixa}</td>
                        <td>{funcao.bpp}</td>
                        <td>{funcao.teto_hr_extra}</td>
                    </tr>
                )
            })
        )

    }

    function handleClickFiltrar() {
        api.get(`/folha${(dpto ? '?dpto=' + dpto : '')}`).then(function (response) {
            if (response.data) {
                setFuncoes(response.data);
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function renderFuncoes() {
        if (funcoes.length > 0) {
            return (
                <table className="table table-sm">
                    <thead>
                        <tr>
                            <th>DEPARTAMENTO</th>
                            <th>FUNÇÃO</th>
                            <th>SALÁRIO BASE</th>
                            <th>GRATIFICAÇÃO FIXA</th>
                            <th>BPP</th>
                            <th>TETO HR 50%</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderRow()}
                    </tbody>
                </table>
            )
        } else {
            return (
                <div>
                    NADA ENCONTRADO
                </div>
            )
        }
    }

    function fechaModalFuncao() {
        setModalFuncaoOpen(false);
    }

    function handleSelectValue(value, obj) {
        const objselected = Object.assign([], obj);
        objselected.selectItem = value;
        return objselected;
    }

    function renderEventosAtrib(eventos) {
        return (
            eventos.map((evento) => {
                return (
                    <tr>
                        <td>
                            {evento.descricao}
                        </td>
                        <td>
                            <BsXCircleFill size="25" color='red' />
                        </td>
                    </tr>
                )
            })
        )
    }

    function renderModalFuncao() {
        return (
            <div className={(modalFuncaoOpen ? "modal-despesas" : "modal-fechado")}>
                <span className="fechar-modal-previsoes" onClick={() => fechaModalFuncao()}><b>x</b></span>
                <div>
                    <h3>{selectedFuncao.descricao}</h3>
                </div>
                <div className={styles.valores}>
                    <div className={styles.columns}>
                        <label>SAL. BASE</label>
                        <input type="text" value={salBase} onChange={(e) => setSalBase(e.target.value)}></input>
                    </div>
                    <div className={styles.columns}>
                        <label>GRAT. FIXA</label>
                        <input type="text" value={gratFixa} onChange={(e) => setGratFixa(e.target.value)}></input>
                    </div>
                    <div className={styles.columns}>
                        <label>BPP</label>
                        <input type="text" value={bpp} onChange={(e) => setBpp(e.target.value)}></input>
                    </div>
                    <div className={styles.columns}>
                        <label>TETO HR 50%</label>
                        <input type="text" value={teto} onChange={(e) => setTeto(e.target.value)}></input>
                    </div>
                </div>
                <label>EVENTOS</label>
                <select
                    className="col-md-12 combobox  edit form-control column-filtro"
                    id="tipo"
                    value={eventos.selectItem}
                    onChange={(e) => setEventos(handleSelectValue(e.target.value, eventos))}
                // ref={tipoRef}
                // onKeyDown={(e) => handledown(e, etapaRef)}
                >
                    {eventos.items.map((item, index) => (
                        <option key={index} value={item.id}>{item.text}</option>
                    ))}
                </select>
                <BsFillPlusCircleFill size="50" color='green' />
                <table className="table table-sm">
                    <thead>
                        <tr>
                            <th colSpan="2">EVENTOS ATRIBUIDOS</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(selectedFuncao.parametros ? renderEventosAtrib(selectedFuncao.parametros) : <></>)}
                    </tbody>
                </table>
            </div>
        )
    }

    return (
        <>
            {renderModalFuncao()}
            <div className="container-lg">
                <Header title="FOLHA" />
                <div>
                    <input type="text" value={dpto} onChange={(e) => setDpto(e.target.value)}></input>
                    <input type="button" onClick={() => handleClickFiltrar()} value="buscar"></input>
                </div>

                {renderFuncoes()}
            </div>
        </>
    )
}